import $ from 'jquery';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    className: 'integration-log-preview',

    events: {
        'click'         : 'onOpen',
    },

    dom_handlers: {
        onOpen: function(e) {
            Modals.openIntegrationLogSidebar(this.model);
        },
    },

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);
    },

    render: function() {
        var integration_info = this.model.getIntegrationInfo() || {};

        var content =
        '<div class="integration-type">' +
            (this.model.get('type') ? '<div class="integration-logo margin-right-8"><img src="' + (integration_info.logo || '') + '"></div>' : '') +
            '<div class="request-type">' + (integration_info.name || '') + '</div>' +
        '</div>' +
        '<div>' +
            '<span class="' + (this.model.isError() ? 'badge-danger-invert' : 'badge-success-invert') + '">' + this.model.getStatusText() + '</span>' +
        '</div>' +
        '<div>' + this.model.get('request_method') + '</div>' +
        '<div class="request-url">' + this.model.escape('request_url') + '</div>' +
        '<div>' + Util.moment(this.model.escape('timestamp'), 'DD MMM YYYY h:mm a', undefined, false) + ' </div>';

        this.$el.html(content);

        return this;
    }
});